/* ═══════════════════════════════════════════════════════════════
   The Master Forma Studio — Watermark palette.

   Ported from the classic editor's inline "ds-watermark" panel
   (app.tsx), restyled onto kit primitives (Input) instead of raw
   <input> + inline hex colors. Same field, same write:
   `special.watermark` — a diagonal gray stamp on every printed page.
   ═══════════════════════════════════════════════════════════════ */

import React from 'react';
import type { StandardConfig } from '../../../shared/types';
import { Input } from '../../components/ui/input';
import { Hint } from '../../components/ui/tooltip';
import { FORMA_TIPS } from '../../formaTooltips';

export function WatermarkPanel({
  forma,
  onEdit,
}: {
  forma: StandardConfig;
  onEdit: (fn: (f: StandardConfig) => StandardConfig) => void;
}) {
  const sp = forma.special || ({} as StandardConfig['special']);
  return (
    <div className="sfs-panel">
      <div className="sfs-panel-card">
        <span className="sfs-panel-eyebrow">Watermark</span>
        <Hint text={FORMA_TIPS.watermark}>
          <Input
            aria-label="Watermark text"
            value={sp.watermark || ''}
            placeholder="e.g. DRAFT, NOT FOR CONSTRUCTION"
            onChange={(e) =>
              onEdit((f) => ({ ...f, special: { ...f.special, watermark: e.target.value } }))
            }
          />
        </Hint>
        <p className="sfs-panel-hint">Diagonal gray text on every page. Leave blank to remove.</p>
      </div>
    </div>
  );
}
